import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { SpanStatusCode } from '@opentelemetry/api'
import { getTracer } from '../services/tracing'

const tracer = getTracer('navigation')

export function NavigationTracker() {
  const location = useLocation()
  const prevPathRef = useRef(location.pathname)

  useEffect(() => {
    const from = prevPathRef.current
    const to = location.pathname
    prevPathRef.current = to

    if (from === to) return

    const span = tracer.startSpan('navigation', {
      attributes: {
        'navigation.from': from,
        'navigation.to': to,
        'navigation.search': location.search,
      },
    })
    span.setStatus({ code: SpanStatusCode.OK })
    span.end()
  }, [location.pathname, location.search])

  return null
}
